<template>
    <section class="gallery-section">
        <div class="section-header">
            <p class="section-kicker">All Media</p>
            <h2 class="section-title">Complete archive</h2>
            <p class="section-copy">
                Browse the full collection of media moments, event highlights, and club memories.
            </p>
        </div>

        <div class="cards">
            <GalleryCard
                v-for="(card, index) in dataList"
                :key="index"
                :title="card.title"
                :content="card.description.length > 200 ? card.description.substring(0, 200) + '...' : card.description"
                :image="card.image"
                :date="card.date"
                @click="openDetails(card)"
            />
        </div>
    </section>
</template>

<script setup>
import GalleryCard from "./CommonCard/GalleryCard.vue";
import axios from "axios";
import { ref, onMounted, watch } from "vue";
import { useRouter, useRoute } from "vue-router";

const route = useRoute();
const router = useRouter();

let base_url = process.env.VUE_APP_BASE_LIVE_URL;
const dataList = ref([]);

watch(
  () => route.query.archive,
  () => {
    listGallery();
  }
);

onMounted(async () => {
  await listGallery();
});

const listGallery = async () => {
  try {
    const archive = route.query.archive;

    const response = await axios.get("/media_gallery_list_all.php", {
      params: archive ? { archive } : {}
    });

    dataList.value = response.data.data.map((data) => ({
      title: data.title,
      description: data.description,
      date: data.date,
      image: `${base_url}/${data.banner_image}`
    }));
  } catch (error) {
    console.error(error.message);
  }
};

const openDetails = (card) => {
  router.push({
    name: "MediaGalleryPage",
    params: {
      title: card.title
    }
  });
};
</script>

<style scoped lang="scss">
.gallery-section {
    width: 100%;
    min-width: 0;
}

.section-header {
    margin-bottom: 24px;
}

.section-kicker {
    margin: 0 0 8px;
    color: #0f5b2b;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
}

.section-title {
    margin: 0;
    font-size: clamp(30px, 3vw, 44px);
    line-height: 1.08;
    font-weight: 700;
    color: #0f172a;
}

.section-copy {
    margin: 10px 0 0;
    max-width: 760px;
    color: #64748b;
    font-size: 16px;
    line-height: 1.7;
}

.cards {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 22px;
}

@media (max-width: 992px) {
    .cards {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 768px) {
    .section-header {
        margin-bottom: 18px;
    }

    .cards {
        grid-template-columns: 1fr;
        gap: 16px;
    }
}
</style>
